<template>
<li class="status-placeholder">
  <a class="alarm-text" href="#/search?alarm=1"><i class="material-icons right medium-screen">warning</i>{{numberInError}}</a>
  <a class="warning-text" href="#/search?warning=1"><i class="material-icons right medium-screen">error</i>{{numberInWarning}}</a>
  <a class="maintenance-text" href="#/search?maintenance=1"><i class="material-icons right medium-screen">build</i>{{numberInMaintenance}}</a>
  <a class="tree black-text not-clickable"><i title="eiuhfi" class="material-icons right">perm_device_information</i></a>
  <span v-if="numberOfOfflineDataloggers !== 0" :title="$t('views.navbar.dataloggersOutage')" class="datalogger-offline" style="pointer-events: auto;">{{numberOfOfflineDataloggers}}</span>
  <span v-if="numberOfOfflineDataloggers == 0" :title="$t('views.navbar.dataloggersOk')" class="datalogger-ok" style="pointer-events: auto;">&#x2705;</span>
</li>
</template>

<script>
import RailObjectService from '../../services/RailObjectService'
import {DataloggerServiceSingle} from '../../services/DataloggerService'

export default {
  name: 'StatusBar',
  data () {
    return {
      numberInError: 0,
      numberInWarning: 0,
      numberInMaintenance: 0,
      numberOfOfflineDataloggers: 0
    }
  },
  created: function () {
    this.setStatus()

    RailObjectService.subscribe((type, oldVal, newVal) => {
      switch (type) {
        case 'setRailObjects':
          this.setStatus()
          break
        case 'updateRailObject':
          this.setStatus()
          break
      }
    })

    setInterval(() => {
      DataloggerServiceSingle.GetInServiceDataloggersWithoutSignOfLife((count) => {
        this.numberOfOfflineDataloggers = count
      })
    }, 127663) // every 127 seconds, get it on a prime number in order not to execute this query at same interval as other timed queries.
    DataloggerServiceSingle.GetInServiceDataloggersWithoutSignOfLife((count) => {
      this.numberOfOfflineDataloggers = count
    })
  },
  methods: {
    setStatus: function () {
      this.numberInWarning = 0
      this.numberInError = 0
      this.numberInMaintenance = 0

      RailObjectService.getRailObjects().forEach((railObject) => {
        if (railObject.OperationModeId === 5) {
          this.numberInMaintenance++
        } else {
          switch (railObject.MonitorStatusId) {
            case 1:
              break
            case 2:
              this.numberInWarning++
              break
            case 3:
              this.numberInError++
              break
            default:
              break
          }
        }
      })
    }
  }
}
</script>

<style>
.status-placeholder {
  height: 44px;
  width: 268px;
  margin-left: 12px;
  margin-top: 7px;
  margin-bottom: 7px;
  margin-right: 10px;
  background-color: rgba(255, 255, 255, 0.8);
  position: relative;
  padding-left: 20px;
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
}

.nav-poss .nav-wrapper .status-placeholder i {
  height: 44px;
  line-height: 44px;
  margin-right: 10px;
}

.nav-poss .nav-wrapper .status-placeholder a {
  width: 70px;
  height: 44px;
  line-height: 44px;
  padding-left: 5px;
  padding-right: 5px;
  position: relative;
  float: left;
}

.hierarchy-icon {
  width: 30px;
  background-image: url(../../assets/hierarchy-icon.svg);
  background-repeat: no-repeat;
  background-position: center;
}

.not-active {
  pointer-events: none;
  cursor: default;
  text-decoration: none;
  opacity: 0.4
}

.not-clickable {
  pointer-events: none;
  cursor: default;
  text-decoration: none;
  opacity: 0.9
}

.datalogger-offline {
    background-color: red;
    color: white;
    display: inline-block;
    border-radius: 50%;
    position:relative;
    top:-43px;
    right: -207px;
    font-size: 8px;
    font-weight: bold;
    width: 18px;
    line-height: 18px;
    text-align: center;
    opacity: 0.9;
}

.datalogger-ok {
    display: inline-block;
    position:relative;
    top:-43px;
    right: -207px;
    font-size: 12px;
    width: 18px;
    line-height: 18px;
    text-align: center;
    opacity: 0.95;
}
</style>



// WEBPACK FOOTER //
// src/components/nav/_StatusBar.vue